import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Skeleton, Tabs, Typography, Breadcrumb } from 'antd';
import payoutReportsAPI from 'services/payoutApi';
import Alert from 'components/Alert';
import './index.scss';
import RegularPayoutSegment from '../PayoutSegment/RegularPayoutSegment/RegularPayoutSegment';
import CustomPayoutSegment from '../PayoutSegment/CustomPayoutSegment/CustomPayoutSegment';
import { getMonthBasedPayoutCards } from './const';

function PayoutMonthReportTabs() {
  const params = useParams();
  const [tabActiveKey, setTabActiveKey] = useState('1');
  const [tabLabel, setTabLabel] = useState('Regular Payouts');
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [partnerPayoutMonthFunnel, setpartnerPayoutMonthFunnel] = useState([]);
  const navigate = useNavigate();

  const yearMonth = params.id;

  const handleOpen = () => {
    navigate('/payout-reports');
  };
  const fetchMonthSummaryCards = async () => {
    setSummaryLoading(true);
    const request = {
      mandatory_check: {
        year_month: yearMonth
      }
    };
    const response = await payoutReportsAPI.getScenerioReportCard(request);
    if (!response?.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
      setSummaryLoading(false);
    }
    setpartnerPayoutMonthFunnel(response?.data?.reports?.[0]);
    setSummaryLoading(false);
  };
  const getMonthBasedPayoutSummaryCards = getMonthBasedPayoutCards(partnerPayoutMonthFunnel);

  const items = [
    {
      key: '1',
      label: 'Regular Payouts',
      children: <RegularPayoutSegment yearMonth={yearMonth} />
    },
    {
      key: '2',
      label: 'Custom Payouts',
      children: <CustomPayoutSegment yearMonth={yearMonth} />
    }
  ];

  const onChange = (activeKey) => {
    setTabActiveKey(activeKey);
    const activeTab = items?.find((item) => item?.key === activeKey);
    setTabLabel(activeTab?.label);
  };

  useEffect(() => {
    fetchMonthSummaryCards();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', padding: '24px' }}>
      <Breadcrumb separator="/">
        <Breadcrumb.Item onClick={handleOpen} className="payout-month-breadcrumb">
          Payouts
        </Breadcrumb.Item>
        <Breadcrumb.Item className="payout-month-breadcrumb">{tabLabel}</Breadcrumb.Item>
      </Breadcrumb>
      <Skeleton
        loading={summaryLoading}
        paragraph={{
          rows: 1,
          width: ['100%', '80%'],
          style: { backgroundColor: '#fff' }
        }}
        title={{ style: { backgroundColor: '#fff' } }}
        style={{ backgroundColor: '#fff', padding: 8, borderRadius: 6 }}
        active
      >
        <div className="payout-report-funnel">
          <div className="main-funnel">
            {getMonthBasedPayoutSummaryCards.length > 1 &&
              getMonthBasedPayoutSummaryCards.map((item) => (
                <div className="cards">
                  <div className="main-img">
                    <div>{item?.rect}</div>
                    <div className="img-overlap">{item?.icon}</div>
                  </div>
                  <div className="funnel-text-div">
                    <Typography.Text className="title">{item?.label}</Typography.Text>
                    <Typography.Text className="text">{item?.value}</Typography.Text>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Skeleton>

      <Tabs activeKey={tabActiveKey} items={items} onChange={onChange} />
    </div>
  );
}

export default PayoutMonthReportTabs;
